import React, { useEffect, useMemo, useState } from 'react';
import { useGetOurPickProductsPaginated } from '../api/product';
import ProductList from '../components/home/ProductList';
import Pagination from '../components/main/Pagination';
import { useBrands } from '../contexts/BrandContext';
import { enhanceProductsWithBrands } from '../utils/brandUtils';
import { useTranslation } from 'react-i18next';
import { useTheme, useMediaQuery } from '@mui/material';

const OurPickDetails: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [currentPage, setCurrentPage] = useState(1);
  const limit = isMobile ? 12 : 20; // Responsive limit: 12 for mobile, 20 for PC
  
  const { productsData, totalPages, productsIsLoading } = useGetOurPickProductsPaginated(currentPage, limit);
  const { brands } = useBrands();

  const { t } = useTranslation();
  
  // Enhance products with brand names using cached brand data
  const products = useMemo(() => {
    if (productsData && brands.length > 0) {
      return enhanceProductsWithBrands(productsData, brands);
    }
    return productsData || [];
  }, [productsData, brands]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div>
      {/* Products List */}
      <ProductList
        products={products}
        loading={productsIsLoading}
        variant="grid"
        title={t('ourPicks.title')}
      />

      {/* Pagination */}
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default OurPickDetails; 